// 营运订单-日营运统计(出租车)
const dailyOperating = (resolve) => {
  import('components/taxi/taxi.operatingDaily').then((module) => {
    resolve(module)
  })
}
// 营运订单-月营运统计(出租车)
const monthlyOperating = (resolve) => {
  import('components/taxi/taxi.operatingMonthly').then((module) => {
    resolve(module)
  })
}
// 营运订单-年营运统计(出租车)
const yearOperating = (resolve) => {
  import('components/taxi/taxi.operatingYear').then((module) => {
    resolve(module)
  })
}
// 营运订单-业务类型统计(出租车)
const businessType = (resolve) => {
  import('components/taxi/taxi.operatingBusinessType').then((module) => {
    resolve(module)
  })
}
// 营运订单-订单明细统计(出租车)
const orderDetail = (resolve) => {
  import('components/taxi/taxi.operatingOrderDetail').then((module) => {
    resolve(module)
  })
}
// 营运订单-订单状态统计(出租车)
const orderStatus = (resolve) => {
  import('components/taxi/taxi.operatingOrderStatus').then((module) => {
    resolve(module)
  })
}
// 营运订单-订单状态统计(出租车)
const dealType = (resolve) => {
  import('components/taxi/taxi.operatingDealType').then((module) => {
    resolve(module)
  })
}
// 营运订单-设备营运统计(出租车)
const equipmentOperation = (resolve) => {
  import('components/taxi/taxi.operatingEquipmentOperation').then((module) => {
    resolve(module)
  })
}
// 电召订单-电召订单年营运统计(出租车)
const getOrderByYear = (resolve) => {
  import('components/taxi/taxi.getOrderByYear').then((module) => {
    resolve(module)
  })
}
// 电召订单-电召订单月营运统计(出租车)
const getOrderByMonths = (resolve) => {
  import('components/taxi/taxi.getOrderByMonths').then((module) => {
    resolve(module)
  })
}
// 电召订单-电召订单日营运统计(出租车)
const getOrderByDay = (resolve) => {
  import('components/taxi/taxi.getOrderByDay').then((module) => {
    resolve(module)
  })
}
// 电召订单-电召订单明细查询(出租车)
const getOrders = (resolve) => {
  import('components/taxi/taxi.getOrders').then((module) => {
    resolve(module)
  })
}
// 电召订单-电召订单状态统计(出租车)
const getOrderByFlag = (resolve) => {
  import('components/taxi/taxi.getOrderByFlag').then((module) => {
    resolve(module)
  })
}
// 电召订单-电召订单设备统计(出租车)
const getOrderByIdno = (resolve) => {
  import('components/taxi/taxi.getOrderByIdno').then((module) => {
    resolve(module)
  })
}
// 服务评价(出租车)
const serviceComment = (resolve) => {
  import('components/taxi/taxi.serviceComment').then((module) => {
    resolve(module)
  })
}
// 设备指令下发报表(出租车)
const commandSend = (resolve) => {
  import('components/taxi/taxi.commandSend').then((module) => {
    resolve(module)
  })
}
// 设备文本下发报表(出租车)
const commandSendText = (resolve) => {
  import('components/taxi/taxi.commandSendText').then((module) => {
    resolve(module)
  })
}
// 投诉登记(出租车)
const complaint = (resolve) => {
  import('components/taxi/taxi.complaint').then((module) => {
    resolve(module)
  })
}
// 营收来源,运距及支付方式
const revenues = (resolve) => {
  import('components/taxi/taxi.revenues').then((module) => {
    resolve(module)
  })
}
// 企业运营日报表
const reportDay = (resolve) => {
  import('components/taxi/taxi.reportDay').then((module) => {
    resolve(module)
  })
}
// 企业运营月报表
const reportMonth = (resolve) => {
  import('components/taxi/taxi.reportMonth').then((module) => {
    resolve(module)
  })
}
// 企业运营年报表
const reportYear = (resolve) => {
  import('components/taxi/taxi.reportYear').then((module) => {
    resolve(module)
  })
}
// 车辆营收排行
const revenueRanking = (resolve) => {
  import('components/taxi/taxi.revenueRanking').then((module) => {
    resolve(module)
  })
}
// 运营里程排行
const mileageRanking = (resolve) => {
  import('components/taxi/taxi.mileageRanking').then((module) => {
    resolve(module)
  })
}
// 里程利用率排行
const utilizationRanking = (resolve) => {
  import('components/taxi/taxi.utilizationRanking').then((module) => {
    resolve(module)
  })
}
// 客单价排行
const unitPriceRanking = (resolve) => {
  import('components/taxi/taxi.unitPriceRanking').then((module) => {
    resolve(module)
  })
}
// 服务评价月报表
const evaluateMonth = (resolve) => {
  import('components/taxi/taxi.evaluateMonth').then((module) => {
    resolve(module)
  })
}
// 司机服务评价排名
const serviceScoreRanking = (resolve) => {
  import('components/taxi/taxi.serviceScoreRanking').then((module) => {
    resolve(module)
  })
}
// 服务投诉月报表
const complaintMonth = (resolve) => {
  import('components/taxi/taxi.complaintMonth').then((module) => {
    resolve(module)
  })
}
// 服务投诉排名
const complaintRanking = (resolve) => {
  import('components/taxi/taxi.complaintRanking').then((module) => {
    resolve(module)
  })
}
// 支出汇总
const spendingSummary = (resolve) => {
  import('components/taxi/taxi.spendingSummary').then((module) => {
    resolve(module)
  })
}
// 加油/充电记录
const refuelRecord = (resolve) => {
  import('components/taxi/taxi.refuelRecord').then((module) => {
    resolve(module)
  })
}
// 维修保养记录
const maintainRecord = (resolve) => {
  import('components/taxi/taxi.maintainRecord').then((module) => {
    resolve(module)
  })
}
// 其他补贴
const otherSubsidy = (resolve) => {
  import('components/taxi/taxi.otherSubsidy').then((module) => {
    resolve(module)
  })
}
// 司机管理及年龄分布
const driverAge = (resolve) => {
  import('components/taxi/taxi.driverAge').then((module) => {
    resolve(module)
  })
}
// 车龄及品牌分布
const autoAge = (resolve) => {
  import('components/taxi/taxi.autoAge').then((module) => {
    resolve(module)
  })
}

const taxiRouter = {
  taxiPath: [{
    path: '/taxi/commandSend', // 设备指令下发报表(出租车)
    component: commandSend,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/taxi/commandSendText', // 设备文本下发报表(出租车)
    component: commandSendText,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/taxi/serviceComment', // 服务评价(出租车)
    component: serviceComment,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/taxi/getOrderByYear', // 电召订单-电召订单年营运统计(出租车)
    component: getOrderByYear,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/taxi/getOrderByMonths', // 电召订单-电召订单月营运统计(出租车)
    component: getOrderByMonths,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/taxi/getOrderByDay', // 电召订单-电召订单日营运统计(出租车)
    component: getOrderByDay,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/taxi/getOrders', // 电召订单-电召订单明细查询(出租车)
    component: getOrders,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/taxi/getOrderByFlag', // 电召订单-电召订单状态统计(出租车)
    component: getOrderByFlag,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/taxi/getOrderByIdno', // 电召订单-电召订单设备统计(出租车)
    component: getOrderByIdno,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/taxi/operatingDealType', // 营运订单-交易类型统计(出租车)
    component: dealType,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/taxi/equipmentOperation', // 营运订单-设备营运统计(出租车)
    component: equipmentOperation,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/taxi/orderStatus', // 营运订单-订单状态统计(出租车)
    component: orderStatus,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/taxi/orderDetail', // 营运订单-订单明细统计(出租车)
    component: orderDetail,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/taxi/businessType', // 电召订单-业务类型统计(出租车)
    component: businessType,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/taxi/yearOperating', // 营运订单-年营运统计(出租车)
    component: yearOperating,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/taxi/monthlyOperating', // 营运订单-月营运统计(出租车)
    component: monthlyOperating,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/taxi/dailyOperating', // 营运订单-日营运统计(出租车)
    component: dailyOperating,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/taxi/complaint', // 投诉登记
    component: complaint,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/taxi/revenues', // 营收来源,运距及支付方式
    component: revenues,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/taxi/reportDay', // 企业运营日报表
    component: reportDay,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/taxi/reportMonth', // 企业运营月报表
    component: reportMonth,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/taxi/reportYear', // 企业运营年报表
    component: reportYear,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/taxi/revenueRanking', // 车辆营收排行
    component: revenueRanking,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/taxi/mileageRanking', // 运营里程排行
    component: mileageRanking,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/taxi/utilizationRanking', // 里程利用率排行
    component: utilizationRanking,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/taxi/unitPriceRanking', // 客单价排行
    component: unitPriceRanking,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/taxi/evaluateMonth', // 服务评价月报表
    component: evaluateMonth,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/taxi/serviceScoreRanking', // 司机服务评价排名
    component: serviceScoreRanking,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/taxi/complaintMonth', // 服务投诉月报表
    component: complaintMonth,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/taxi/complaintRanking', // 服务投诉排名
    component: complaintRanking,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/taxi/spendingSummary', // 支出汇总
    component: spendingSummary,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/taxi/refuelRecord', // 加油/充电记录
    component: refuelRecord,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/taxi/maintainRecord', // 维修保养记录
    component: maintainRecord,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/taxi/otherSubsidy', // 其他补贴
    component: otherSubsidy,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/taxi/driverAge', // 司机管理及年龄分布
    component: driverAge,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/taxi/autoAge', // 车龄及品牌分布
    component: autoAge,
    meta: {
      keepAlive: false
    }
  }
  ]
}

export default taxiRouter



// WEBPACK FOOTER //
// ./src/router/taxi.js